export enum TicketVisibility {    
    Public = 0,
    Center = 1,
    Nkr = 2
}